import { render, staticRenderFns } from "./ItemMenu.vue?vue&type=template&id=52169b87&scoped=true"
import script from "./ItemMenu.vue?vue&type=script&lang=js"
export * from "./ItemMenu.vue?vue&type=script&lang=js"
import style0 from "./ItemMenu.vue?vue&type=style&index=0&id=52169b87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52169b87",
  null
  
)

export default component.exports